
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as GoogleClassroomIconComponent } from "./google-classroom-icon.svg";

export const GoogleClassroomIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <GoogleClassroomIconComponent {...props} />;
};
